import React from 'react';
import get from 'lodash/get';
import { observer } from 'mobx-react';
import OptimizeImagesService from 'services/OptimizeImages.service';
import JobOffersStore from 'stores/JobOffers.store';

import styles from './ListWithImages.module.scss';

const ListWithImages = () => {
  const content = get(JobOffersStore, 'jobOffersPageContent.benefits', []);
  return (
    <div>
      {content.map((item, i) => (
        <div key={i} className={styles.ListItem}>
          <img
            src={OptimizeImagesService.adjustImageSize(item.image)}
            className={styles.ListItemImage}
            alt="Icon"
          />
          <span className={styles.ListItemText}>{item.text}</span>
        </div>
      ))}
    </div>
  );
};

export default observer(ListWithImages);



// WEBPACK FOOTER //
// ./src/views/JobOffers/components/Article/ListWithImages/ListWithImages.js